import { Link, useLocation, Outlet } from 'react-router-dom';
import { FileText, Building2, PlusCircle, ClipboardList, BarChart3, Menu } from 'lucide-react';
import { useState } from 'react';

export default function Layout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigation = [
    { name: '首页', path: '/', icon: FileText },
    { name: '模板管理', path: '/templates', icon: FileText },
    { name: '公司信息', path: '/companies', icon: Building2 },
    { name: '核心条款', path: '/clauses', icon: ClipboardList },
    { name: '生成合同', path: '/generate', icon: PlusCircle },
    { name: '合同报表', path: '/records', icon: BarChart3 },
  ];

  return (
    <div className="min-h-screen bg-sidebar flex flex-col">
      {/* 顶部导航栏 */}
      <header className="bg-white border-b border-gray-200 h-14 flex items-center px-4 sticky top-0 z-30 shadow-sm">
        <div className="flex items-center justify-between w-full max-w-screen-2xl mx-auto">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-1.5 rounded-lg hover:bg-gray-100"
            >
              <Menu className="w-5 h-5 text-gray-600" />
            </button>
            <Link to="/" className="flex items-center gap-2">
              <FileText className="w-6 h-6 text-primary" />
              <span className="text-lg font-bold text-gray-800">合同生成工具</span>
            </Link>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.path ||
                (item.path !== '/' && location.pathname.startsWith(item.path));
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary/10 text-primary'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {item.name}
                </Link>
              );
            })}
          </nav>
          <div className="text-xs text-gray-400">v1.0 | 本地安全处理</div>
        </div>
      </header>

      {/* 移动端菜单 */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-black/30" onClick={() => setMobileMenuOpen(false)}>
          <div className="bg-white w-64 h-full shadow-lg p-4" onClick={(e) => e.stopPropagation()}>
            <div className="mb-4 font-bold text-gray-800">功能菜单</div>
            <nav className="flex flex-col gap-1">
              {navigation.map((item) => {
                const isActive = location.pathname === item.path;
                const Icon = item.icon;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium ${
                      isActive ? 'bg-primary/10 text-primary' : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    <Icon className="w-4 h-4" />
                    {item.name}
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>
      )}

      {/* 主内容区 */}
      <main className="flex-1 w-full max-w-screen-2xl mx-auto px-4 py-6">
        <Outlet />
      </main>

      {/* 底部 */}
      <footer className="bg-white border-t border-gray-200 py-4 text-center text-xs text-gray-400">
        <div className="max-w-screen-2xl mx-auto px-4">
          <p>合同生成工具 &copy; {new Date().getFullYear()} - 所有数据本地处理，不上传服务器</p>
          <p className="mt-1">
            <a href="#" className="hover:text-primary">使用帮助</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-primary">隐私说明</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
